import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const StrategicConsultation = () => {
  return (
    <>
      <SEO 
        title="Strategic Technology Consultation - Abacies Logiciels"
        description="Get expert technology strategy consulting to align your IT initiatives with business goals. Technology roadmaps, digital transformation strategy, AI adoption planning, and architecture consulting."
        keywords="strategic consultation, technology consulting, IT strategy, digital transformation consulting, technology roadmap, AI strategy"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Strategic Consultation
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Strategic Consultation page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Strategic Consultation. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default StrategicConsultation;
